export enum InvoiceType {
  NORMAL = 'NORMAL',
  CASH = 'CASH', // An invoice that is paid directly when received, this is the case for card payments.
  CREDIT = 'CREDIT',
  ESCROW = 'ESCROW',
  PREPAYMENT = 'PREPAYMENT',
}

export enum ExternalInvoiceType {
  PREPAYMENT = 'PREPAYMENT',
  NORMAL = 'NORMAL',
}
